import { Navigate, Route, Routes } from 'react-router-dom'
import { useApp } from 'store/steps'
import TemporarySelfcareModal from './modals/TemporarySelfcareModal'
import NotFound from 'routes/NotFound'
import MarchPromoManageOrder from './views/MarchPromoManageOrder'
import MarchPromoSummary from './views/MarchPromoSummary'
import { GuestsDataProvider } from 'components/common/MarchPromo/utils/guestsDataProvider'
import OrderAndPayment from './views/OrderAndPayment'

const MarchPromoRoutes = () => {
    const { getPath } = useApp()

    return (
        <GuestsDataProvider>
            <Routes>
                <Route
                    path="/"
                    element={<Navigate to={getPath('edit_order')} />}
                />
                <Route
                    path={getPath('edit_order')}
                    element={<MarchPromoManageOrder />}
                />
                <Route
                    path={getPath('summary')}
                    element={<MarchPromoSummary />}
                />
                <Route
                    path={getPath('selfcare_order')}
                    element={<OrderAndPayment />}
                />
                <Route path="/modal" element={<TemporarySelfcareModal />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </GuestsDataProvider>
    )
}

export default MarchPromoRoutes
